var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toaster-wrapper"},[_c('b-toaster',{attrs:{"name":"global-toaster"}}),_c('AnalysisToast')],1)}
var staticRenderFns = []

export { render, staticRenderFns }